import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { naira } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  const soldOut = (product.stock ?? 0) <= 0;
  const onSale = product.salePrice && product.salePrice < product.price;

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block">
        <div className="relative overflow-hidden bg-sand rounded-2xl aspect-[4/5]">
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute top-3 left-3 flex gap-2">
            {soldOut && (
              <span className="bg-espresso text-bone text-[10px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full">
                Sold out
              </span>
            )}
            {!soldOut && onSale && (
              <span className="bg-terracotta text-bone text-[10px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full">
                Sale
              </span>
            )}
          </div>
          {!soldOut && (
            <button
              data-testid={`quick-add-${product.id}`}
              onClick={(e) => {
                e.preventDefault();
                add(product, 1);
              }}
              className="absolute bottom-3 right-3 w-11 h-11 rounded-full bg-bone/95 text-espresso flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-terracotta hover:text-bone shadow-sm"
              aria-label="Add to cart"
            >
              <Plus className="w-5 h-5" strokeWidth={1.8} />
            </button>
          )}
        </div>
      </Link>
      <div className="pt-4">
        <p className="overline text-bark mb-1">{product.category}</p>
        <Link to={`/product/${product.id}`}>
          <h3 className="font-serif text-xl md:text-2xl text-espresso leading-tight hover:text-terracotta transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-baseline gap-2 mt-1">
          <span className="text-espresso font-semibold">{naira(product.salePrice || product.price)}</span>
          {onSale && <span className="text-bark line-through text-sm">{naira(product.price)}</span>}
        </div>
      </div>
    </motion.div>
  );
};
